import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectInventoryData = state => selectState(state).data;
export const selectInventoryLoading = state => selectState(state).loading;
export const selectfetchInventoryLoading = state => selectState(state).inventoryLoading;
export const selectInventoryError = state => selectState(state).error;
export const selectInventoryFilterVisible = state => selectState(state).filterVisible;
export const selectInventoryFilters = state => selectState(state).filters;
export const selectInventoryDetailFilter = state => selectState(state).detailFilters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectedInventory = state => selectState(state).inventoryData;
export const selectFilteredInventories = createSelector(
  [selectInventoryData, selectInventoryFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
export const selectFilteredInventoryDetail = createSelector(
  [selectedInventory, selectInventoryDetailFilter],
  ({ parts, ...restObject }, { searchText }) => {
    const listToexclude = ['id', 'partId', 'partNumber','downloadedFile'];
    const filteredParts = parts.filter(entry => {
      return Object.keys(entry).some(key => {
        return !listToexclude.includes(key) && String(entry[key]).toLowerCase().includes(searchText.toLowerCase())
      }

      )
    });
 
    return {
      ...restObject,
      parts: searchText ? filteredParts : parts
    }
  },
);
